// extracted by css-extract-rspack-plugin
export default {"labelTextColor":"src-domain-components-deployment-target-devices-tab-useDeploymentVirtualDevicesTabColumns-module__labelTextColor-sm4lOT"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"labelTextColor\":\"src-domain-components-deployment-target-devices-tab-useDeploymentVirtualDevicesTabColumns-module__labelTextColor-sm4lOT\"}";
        // 1792611263495
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  